import type { i18n } from 'i18next'
import { VariableValue } from './OrderVariables'

// Priority order for tl variant suffixes: translationPath > flowName > type
export const buildStepTlVariants = ({
  translationPath,
  flowName,
  type,
}: {
  translationPath?: string | null
  flowName?: string | null
  type?: VariableValue
}): string[] => {
  const variants: string[] = []
  if (translationPath) variants.push(translationPath)
  if (flowName) variants.push(flowName)
  if (type) variants.push(type.toString())
  return variants
}

export type StepItemKey =
  | 'title'
  | 'desc'
  | 'label'
  | 'stepDesc'
  | 'price.value'

// Returns the first existing i18n key from variant-specific candidates,
// falling back to `${prefix}.${key}`. Returns undefined if none exist.
export const resolveStepItemKey = ({
  prefix,
  tlVariants,
  key,
  i18n,
}: {
  prefix: string
  tlVariants: string[]
  key: StepItemKey
  i18n: i18n
}): string | undefined => {
  const candidates = [
    ...tlVariants.map((v) => `${prefix}.${v}.${key}`),
    `${prefix}.${key}`,
  ]
  return candidates.find((k) => i18n.exists(k))
}
